import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, UUID, ITEM } from '@/plugins/sdk/fields'
import RateType from '@/plugins/sdk/resources/Dictionary/RateType'
import RateCardRate from '@/plugins/sdk/resources/RateCard/Rate'

export default class extends Resource {
  static name = 'ratecard_pricebreak'

  static get fields () {
    return {
      id: new UUID(),
      break: new NUMBER(),
      basic: new NUMBER(),
      cost: new NUMBER(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      rate: new ITEM(RateCardRate),
      rate_type: new ITEM(RateType)
    }
  }
}
